import React from 'react'
import { Link } from 'react-router'
import type { City } from 'api/api.types'
import styles from './CityPicker.module.scss'

type CityPickerProps = {
  cities: City[],
  selectedCityId: number | null,
  /** Gets the click too, so a caller inside a hash modal can keep the «#» link from closing it */
  onSelectCity: (cityId: number, event: React.MouseEvent) => void,
}

export const CityPicker: React.FC<CityPickerProps> = (props) => {
  const { cities, selectedCityId, onSelectCity } = props
  return (
    <div className={styles.container}>
      <div className={styles.nameContainer}>
        <span className={styles.headerText}>Выберете ваш город:</span>
      </div>
      <div className={styles.CityMobile} />
      <div>
        <ul className={styles.ulStyle}>
          {cities.map(({ city }) => (
            <li key={city.id}>
              <Link
                to={'#'}
                className={selectedCityId === city.id ? styles.ulSpanStyleActiveCity : styles.ulSpanStyle}
                onClick={(event) => onSelectCity(city.id, event)}
              >
                {city.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.footerTextContainer}>
        <div className={styles.footerText}>
          Для отображения корректной информации на сайте,
          подтвердите своё местоположение. Спасибо.
        </div>
      </div>
    </div>
  )
}
